import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "../../styles/Visit.scss";

interface VisitItem {
  id: number;
  image_url: string;
  name: string;
  description: string;
  destination?: string;
  location: string;
}

export default function Visit() {
  const [visitData, setVisitData] = useState<VisitItem[]>([]);

  useEffect(() => {
    fetch("/resources/visit.json")
      .then((res) => res.json())
      .then(setVisitData)
      .catch(console.error);
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4200,
    pauseOnHover: false,
    arrows: false,
  };

  return (
    <section className="visit-section">
      <h2 className="visit-title">Must Visit Destinations</h2>

      <Slider {...settings} className="visit-slider">
        {visitData.map((item) => (
          <div key={item.id} className="visit-slide">
            <div
              className="visit-image"
              style={{ backgroundImage: `url(${item.image_url})` }}
            >
              <div className="visit-overlay" />

              <div className="visit-text">
                <div className="visit-left">
                  <h3 className="visit-name">{item.name}</h3>
                  <p className="visit-description">{item.description}</p>
                </div>

                <div className="visit-right">
                  {item.destination && (
                    <p className="visit-destination">{item.destination}</p>
                  )}
                  <p className="visit-location">{item.location}</p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
}
